module.exports = __webpack_public_path__ + "img/HomeScreenshot-1250h.d305901a.webp";